import * as React from "react";

function SvgSalesforce(props, ref) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 70 60" {...{ ...props, ref }}>
      <path
        d="M26.62 14.492c2.068-2.142 4.95-3.497 8.126-3.497 4.235 0 7.905 2.364 9.875 5.86a13.635 13.635 0 015.6-1.182c7.634 0 13.8 6.23 13.8 13.913S57.82 43.5 50.2 43.5a13.84 13.84 0 01-2.709-.271 10.097 10.097 0 01-8.816 5.17c-1.576 0-3.078-.37-4.408-1-1.748 4.112-5.836 7.018-10.59 7.018a11.5 11.5 0 01-10.8-7.535 10.85 10.85 0 01-2.192.222C4.777 47.095 0 42.27 0 36.285a10.82 10.82 0 015.344-9.357 12.195 12.195 0 01-1.034-4.95C4.285 15.157 9.875 9.59 16.72 9.59a12.41 12.41 0 019.899 4.9"
        fill="#00a1e0"
      />
    </svg>
  );
}

export default React.forwardRef(SvgSalesforce);
